import VTooltip from 'v-tooltip'
// A plugin file where you could register global components used across the app
import GlobalComponents from './globalComponents'
// A plugin file where you could register global directives
import GlobalDirectives from './globalDirectives'

// asset imports
import 'bootstrap/dist/css/bootstrap.css'
// Vuetify 3 のリセット CSS。v3 と同じく Bootstrap の後に読み込む
import './assets/css/vuetify3-reset.css'
import './assets/css/demo.css'
import './assets/sass/light-bootstrap-dashboard.scss'

/**
 * This is the main Light Bootstrap Dashboard Vue plugin where dashboard related plugins are registerd.
 */
export default {
  install (Vue:any) {
    Vue.use(GlobalComponents)
    Vue.use(GlobalDirectives)
    Vue.use(VTooltip)
  }
}
